const _isDev =
  window.location.hostname === 'localhost' ||
  new URLSearchParams(window.location.search).has('preview_theme_id');

if (!customElements.get('product-share')) {
  customElements.define(
    'product-share',
    class ProductShare extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        // Initialize the AbortController
        this.abortController = new AbortController();

        this.btnCopy = this.querySelector('.btn-copy');
        if (this.btnCopy) {
          this.btnCopy.addEventListener('click', this.copyToClipboard.bind(this), {
            signal: this.abortController.signal,
          });
        }
      }

      copyToClipboard(evt) {
        evt.preventDefault();

        const input = evt.target.previousElementSibling;
        if (!input || !input.value) return;

        navigator.clipboard
          .writeText(input.value)
          .then(() => {
            this.btnCopy.classList.add('copied');
            this.btnCopy.innerText = evt.target.dataset.copiedText || 'Copied!';
          })
          .catch((e) => {
            if (_isDev) console.error('[ProductShare] clipboard.writeText failed:', e);
          });
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }
  );
}
